import { useContext } from 'react';

import Cookies from 'js-cookie';

import { LayoutContext } from '../../baseLayout/provider.jsx';

import SvgIcon from '@/components/SvgIcon';

const SearchHistoryListPop = ({ searchList, recommendDropWordList, hidePop, handleClickKeyWord }) => {
  const { isMro } = useContext(LayoutContext);
  const titleWrapClassName = 'flex items-center justify-between mb-[11px]';
  const titleClassName = 'font-bold text-[14px] leading-[19px]';
  const listClassName =
    'flex items-center text-[#56657F] text-[12px] leading-[16px] mb-[10px] overflow-y-hidden max-h-[78px]';

  function removeHistory() {
    const key = !isMro ? 'searchHistoryRecord' : 'mroSearchHistoryRecord';
    Cookies.set(key, '', {
      domain: '.szlcsc.com',
      expires: 30,
      path: '/',
    });
    hidePop();
  }

  return (
    <section id="search-list-pop">
      {searchList?.length ? (
        <>
          <p className={titleWrapClassName}>
            <span className={titleClassName}>搜索记录</span>
            <SvgIcon
              app="common"
              iconName="remove"
              className="w-[16px] h-[16px] cursor-pointer"
              onClick={removeHistory}
            />
          </p>
          <ul className={listClassName + ' flex-wrap'}>
            {searchList?.map((t, i) => (
              <li
                className="mb-[10px] mr-[15px] cursor-pointer hover:text-[#0093e6]"
                key={i}
                onClick={() => handleClickKeyWord({ clickedkeyWord: t.word, keyWordIdx: i, type: 'history' })}
              >
                <span className="w-[100%] text-ellipsis overflow-hidden">{t.word}</span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <></>
      )}
      {recommendDropWordList?.length ? (
        <>
          <p className={titleWrapClassName}>
            <span className={titleClassName}>热门推荐</span>
          </p>
          <ul className={listClassName + ' flex-wrap'}>
            {recommendDropWordList?.map((word, i) => (
              <li
                className="mb-[10px] mr-[15px] cursor-pointer index hover:text-lcBlue"
                key={i}
                onClick={() => handleClickKeyWord({ clickedkeyWord: word, keyWordIdx: i, type: 'recommend' })}
              >
                <span title={word}>{word}</span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <></>
      )}
    </section>
  );
};

export default SearchHistoryListPop;
